import { useSearchParams } from 'react-router-dom';

/**
 * The comment the URL points at (`?comment=<id>`): where a notification
 * about a reply sends you, so the thread can show that message.
 */
export const useLinkedCommentId = (): string | null =>
  useSearchParams()[0].get('comment');
